import React from 'react';
import PropTypes from 'prop-types';
import {I18nUtils} from "../../../i18n/I18nUtils";
import OutsourceTreeItem from "./OutsourceTreeItem";

export default class OutsourceTree extends React.Component {

  addOutsource(){
    if (this.props.contracts){
      this.props.contracts.push({
        contract_id: Math.random() * -1,
        company: {
          id: -1,
          name: '',
          level: 1
        },
        can_add: true,
        can_remove: true,
        children: []
      });
      this.forceUpdate();
    }
  }

  renderItems(){
    if (!this.props.contracts){
      return null;
    }
    return this.props.contracts.map((contract, i) => {
      return [
        <OutsourceTreeItem
          contract={contract}
          key={i}
          onRemoveChildren={(id) => {
            for(let i = 0; i < this.props.contracts.length; i++){
              if (this.props.contracts[i].contract_id === id ){
                this.props.contracts.splice(i, 1);
                break;
              }
            }
            this.forceUpdate();
          }}
          onAddChildren={() => {
            contract.children.push({
              contract_id: Math.random() * -1,
              company: {
                id: -1,
                name: '',
                level: contract.company.level + 1,
              },
              can_add: true,
              can_remove: true,
              children: []
            });
            this.forceUpdate();
          }}
          allowRemoveChildren={this.props.firstLevelCanRemoved}
        />,
        this.props.showSeparators && i !== this.props.contracts.length - 1 ? <hr/> : null,
      ];
    });
  }

  renderAllowAddContractToFirstLevel() {
    if (this.props.allowAddContractToFirstLevel) {
      return (
        <div className="row">
          <div className="col-xs-10">
            <h4><span className="label bg-orange">1</span> {I18nUtils.tr('TR_ANADE_SUBCONTRATA')}</h4>
          </div>
          <div className="col-xs-2">
            <a onClick={this.addOutsource.bind(this)}>
              <span className="badge pull-right">
                  <i className="material-icons">add</i>
              </span>
            </a>
          </div>
        </div>
      );
    }
  }

  render() {
    return (
      <div>
        {this.renderAllowAddContractToFirstLevel()}
        <div className="work-tree">
          <ul>
            {this.renderItems()}
          </ul>
        </div>
      </div>
    );
  }

}


OutsourceTree.propTypes = {
  contracts: PropTypes.any,
  allowAddContractToFirstLevel: PropTypes.bool,
  firstLevelCanRemoved: PropTypes.bool,
  showSeparators: PropTypes.bool,
};

OutsourceTree.defaultProps = {
  allowAddContractToFirstLevel: true,
  firstLevelCanRemoved: true,
  showSeparators: false,
};



// WEBPACK FOOTER //
// ./src/app/works/components/OutsourceTree.js